import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { jsonp } from '@ifeng-fe/ui_base';
import { isGrounds } from '@src/public/utils/app';
import { QRCODE_PREFIX, QRCODE_VERSION } from '@src/public/constants';

export const getQrCode = async ({ url, short = true }) => {
    // 获取短连接的回调函数
    const callbackNameShort = 'getShortCallback';
    // 获取二维码的回调函数
    const callbackNameQrcode = 'getQrCodeCallback';

    // 最后要返回的二维码链接
    let newImg = '';

    // 拼出qrcode在localStorage中存储的key
    const key = `${QRCODE_PREFIX}${url}`;

    try {
        // 通过key获取localStorage中存储的数据
        const qrocodeItem = localStorage.getItem(key);

        // 如果有数据
        if (qrocodeItem) {
            // 序列化数据
            const qrcodeData = JSON.parse(qrocodeItem);

            // 获取link：二维码链接，expires：过期时间，单位为ms
            const { link, expires, version } = qrcodeData;

            // 判断link和expires是否存在
            if (link && expires && version === QRCODE_VERSION) {
                // 判断是否已过期
                const isExpired = dayjs().isAfter(dayjs(expires));

                if (!isExpired) {
                    // 如果未过期
                    newImg = link;
                }
            }
        }
    } catch (e) {
        console.error(e);
    }

    if (!newImg) {
        // 如果没有从本地存储中获取数据
        // 用传入的原始链接链接生成短链（安卓部分机型存在无法识别较长链接二维码的问题）
        let shortUrl = '';

        if (short) {
            try {
                const res = await jsonp('https://s.ifeng.com/api/create', {
                    data: {
                        url,
                        callback: callbackNameShort,
                    },
                    jsonCallback: callbackNameShort,
                    cache: false,
                });

                const { data } = res;
                const { shorturl } = data;

                shortUrl = shorturl;
            } catch (e) {
                console.error(e);
            }
        }

        // 用上一步的短链生成二维码
        const res = await jsonp('https://qrcode.ifeng.com/qrcode.php', {
            data: {
                url: shortUrl || url,
                callback: callbackNameQrcode,
            },
            jsonCallback: callbackNameQrcode,
            cache: false,
        });

        const { qrcode_url } = res;

        if (qrcode_url) {
            // 如果成功的从接口中获取数据
            newImg = `https:${qrcode_url}`;
            try {
                const qrcodeData = {
                    link: newImg,
                    expires: dayjs()
                        .add(7, 'day')
                        .valueOf(),
                    version: QRCODE_VERSION,
                };

                localStorage.setItem(key, JSON.stringify(qrcodeData));
            } catch (e) {
                console.error(e);
            }
        }
    }

    return newImg;
};

export const useQrCodeUrl = ({ url, short = true, filter = () => isGrounds }) => {
    // 最终生成的二维码链接的state
    const [img, setImg] = useState('');

    useEffect(
        () => {
            // 根据参数filter函数的返回值判断是否需要继续执行，默认为端内才走二维码流程
            const filterResult = filter();

            if (filterResult) {
                getQrCode({ url, short }).then(data => {
                    setImg(data);
                });
            }
        },
        [url, short, filter],
    );

    return img;
};

// 无用的方法，但是可以用作img url转blob url的参考
// const useQrCodeBlobUrl = url => {
//     const [blobUrl, setBlobUrl] = useState('');
//     const callbackName = 'getQrCode';
//
//     const getQrCodeBlobUrl = async url => {
//         try {
//             // 获取二维码图片链接
//             const res = await jsonp('https://qrcode.ifeng.com/qrcode.php', {
//                 data: {
//                     url,
//                     callback: callbackName,
//                 },
//                 jsonCallback: callbackName,
//                 cache: false,
//             });
//
//             console.log(res);
//             const { qrcode_url } = res;
//
//             // 获取二维码图片的实例
//             const img = await new Promise((resolve, reject) => {
//                 const img = new Image();
//
//                 img.onload = () => {
//                     resolve(img);
//                 };
//                 img.onerror = e => {
//                     reject(e);
//                 };
//                 img.crossOrigin = 'anonymous';
//                 img.src = `https:${qrcode_url}`;
//             });
//
//             // 生成canvas实例
//             const canvas = document.createElement('canvas');
//
//             // 设置canvas实例的宽高
//             canvas.width = img.width;
//             canvas.height = img.height;
//
//             // 获取canvas实例的2d上下文
//             const ctx = canvas.getContext('2d');
//
//             // 绘制图片
//             ctx.drawImage(img, 0, 0);
//
//             // 创造canvas实例的blob对象
//             const blob = await new Promise(resolve => {
//                 canvas.toBlob(blob => {
//                     resolve(blob);
//                 });
//             });
//
//             // blob url
//             const blobUrl = URL.createObjectURL(blob);
//
//             // 设置state
//             setBlobUrl(blobUrl);
//         } catch (e) {
//             console.error(e);
//         }
//     };
//
//     useEffect(() => {
//         getQrCodeBlobUrl(url);
//     }, []);
//
//     return blobUrl;
// };
